import React from 'react';

import CompareCarIcon from '@/components/icons/compare-car-icon';
import { handleClick } from '@/components/button/utils/handle-click';
import { Button } from '@/components/ui/button';

export type CompareCarsProps = {
  compareButtonProps: {
    count: number;
    onOpenComparison: () => void;
  };
};

const CompareCars = ({ compareButtonProps }: CompareCarsProps) => {
  const { count, onOpenComparison } = compareButtonProps;
  const compareText = `Compare: ${count}`;
  const hasCount = count > 0;

  return (
    <Button
      type="button"
      variant={hasCount ? 'primary' : 'secondary'}
      size="sm"
      onClick={(e) => handleClick({ event: e, eventText: compareText, onClick: onOpenComparison })}
      className="px-3 [&_svg]:size-5 lg:h-14 lg:px-6 ml-6"
    >
      <CompareCarIcon aria-hidden />
      <span className="mr-1 sr-only lg:not-sr-only">{compareText}</span>
      <span className="text-lg block lg:hidden" aria-hidden>
        {count}
      </span>
    </Button>
  );
};

export default CompareCars;
